module.exports = __webpack_public_path__ + "img/elastic.0a955b19.png";